var SaveDesign = {
    prepareThumbnails: function() {
        ub.funcs.deactivateMoveTool();
        ub.funcs.removeLocations();

        ub.front_view.visible = true;
        ub.back_view.visible = true;
        ub.left_view.visible = true;
        ub.right_view.visible = true;

        ub.current_material.settings.thumbnails = {
            front_view: "",
            back_view: "",
            left_view: "",
            right_view: "",
        };

        ub.current_material.settings.thumbnailsLowRes = {
            front_view: "",
            back_view: "",
            left_view: "",
            right_view: "",
        };

        if (typeof ub.data.previousThumbnails === "undefined") {
            ub.data.previousThumbnails = {
                front_view: "",
                back_view: "",
                left_view: "",
                right_view: "",
            }
        }

        SaveDesign.uploadThumbnailUniformPreview("front_view");
        SaveDesign.uploadThumbnailUniformPreview("back_view");
        SaveDesign.uploadThumbnailUniformPreview("left_view");
        SaveDesign.uploadThumbnailUniformPreview("right_view");
    },

    uploadThumbnailUniformPreview: function(view) {
        var _dataUrl = ub.getThumbnailImage(view);
        ub.data.previousThumbnails[view] = _dataUrl;

        SaveDesign.uploadThumbnails(_dataUrl, function(response) {

            if (response.success) {
                ub.current_material.settings.thumbnails[view] = response.filename;
                $("#richardson-saving-option .uniform-thumbnail-container ." + view + " img").attr('src', response.filename);
                
                if (ub.funcs.thumbnailsUploaded()) {
                    SaveDesign.generatePDFandDesignNumber();
                }

                SaveDesign.uploadLowResPreview(response.filename, view);
            } else {
                ub.utilities.info('Error generating thumbnail for ' + view);
                SaveDesign.onErrorOnUploadingThumbnail();
            }

        }, function() {
            ub.utilities.info('Error generating thumbnail for ' + view);
            SaveDesign.onErrorOnUploadingThumbnail();
        });
    },

    uploadLowResPreview: function(filename, view) {
        Jimp.read(filename)
        .then(function (image) {
            image
            .resize(256, 256)
            .getBase64(Jimp.MIME_PNG, function (err, src) {
                var image = src;

                SaveDesign.uploadThumbnails(image, function(res) {
                    if (res.success) {
                        ub.current_material.settings.thumbnailsLowRes[view] = res.filename;
                    }
                });
            });
        })
        .catch(function(err) {
            console.error(err);
        });
    },

    uploadThumbnails: function(image, successHandler, errorHandler) {
        $.ajax({
            data: JSON.stringify({ dataUrl: image }),
            url: ub.config.host + "/saveLogo",
            dataType: "json",
            type: "POST",
            contentType: 'application/json',
            success: successHandler,
            error: errorHandler
        });
    },

    generatePDFandDesignNumber: function() {
        var designPayload = SaveDesign.prepareSaveDesignPayload();
        var errorMessage = 'Something went wrong while generating the PDF. Please try again later. Send your feedback if the problem persists. We appreciate your comments. Our team will be working on it as soon as possible.';
        // For Updating save design
        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            designPayload.id = ub.config.savedDesignInfo.savedDesignID;
            designPayload.builder_customizations = designPayload.builder_customizations;

            delete designPayload.user;
            delete designPayload.material_name;
        }

        ub.utilities.info("Generating DESIGN NUMBER")
        
        SaveDesign.postSaveDesign(designPayload, function(response) {
            if (response.success) {
                ub.current_material.settings.savedDesignID = response.sd_id;
                ub.current_material.settings.design_number_magento = response.sd_id;
                ub.utilities.info("Generating PDF");
                
                PdfPanel.pdfBuilder(function(response) {
                    if (response.success) {
                        $('#richardson-saving-option .save-design-loading').fadeOut();
                        $("#richardson-saving-option .design-preview").removeClass("uk-hidden");
                        $("#richardson-saving-option .uniform-thumbnail-container").removeClass("uk-hidden");
                        // PDF Order Form
                        ub.current_material.settings.uniformPreviewPdf = response.pdfUrl;
                        ub.current_material.settings.pdfOrderForm = response.pdfUrl;
                        ub.data.rosterIsChange = false;
                    } else {
                        UIkit.modal("#richardson-saving-option").hide();                    
                        ub.funcs.showNotification(errorMessage, "danger", 3000);
                    }
                }, function(error) {
                    UIkit.modal("#richardson-saving-option").hide();
                    ub.funcs.showNotification(errorMessage, "danger", 3000);
                })
            } else {
                ub.utilities.info('Error Saving Design.');
                UIkit.modal("#richardson-saving-option").hide();
            }
        }, function(error) {
            ub.utilities.info('Error Saving Design.');
            UIkit.modal("#richardson-saving-option").hide();
        });
    },

    postSaveDesign: function(data, successHandler, errorHandler) {
        var _url = window.ub.config.api_host + '/api/saved_design'

        if (ub.data.updateSaveDesignFromCustomArtworkRequest) {
            _url = window.ub.config.api_host + '/api/saved_design/update';
        }

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') {
            data.test_data = '1';
        }
        
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {
                "accessToken": null
            },
        
            success: successHandler,

            error: errorHandler
        });
    },

    updateSavedDesignBuilderCustomization: function(successHandler, errorHandler) {
        var _url = ub.config.api_host + '/api/saved_design/update';

        // Skip notification when coming from local
        if (ub.config.app_env === 'local') {
            data.test_data = '1';
        }
        
        if (typeof $.ajaxSettings.headers !== "undefined") {
            delete $.ajaxSettings.headers["X-CSRF-TOKEN"];
        }

        var designPayload = SaveDesign.prepareSaveDesignPayload();

        var _data = {
            id: ub.current_material.settings.savedDesignID,
            user_id: "2974",
            name: "Richardson Saved Design",
            material_id: designPayload.material_id,
            builder_customizations: designPayload.builder_customizations,
            sport: designPayload.sport,
            front_thumbnail: designPayload.front_thumbnail,
            back_thumbnail: designPayload.back_thumbnail,
            left_thumbnail: designPayload.left_thumbnail,
            right_thumbnail: designPayload.right_thumbnail,
            notes: "Richardson Saved Design",
            brand_id: ub.config.brand_id
        };

        $.ajax({
            url: _url,
            dataType: "json",
            type: "POST",
            data: JSON.stringify(_data),
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": null},
        
            success: successHandler,
            error: errorHandler
        });
    },

    prepareSaveDesignPayload: function() {
        if (typeof PartInformation !== "undefined") {
            PartInformation.initialize(
                ub.data.modifierLabels,
                ub.current_material.settings
            )
        }

        var _userID = ub.user.id;
        var _designName = "Richardson Saved Design";
        var _materialID = ub.current_material.material.id;
        var _builderCustomizations = ub.current_material.settings;
        var _sport = ub.current_material.material.uniform_category;
        var _frontView = ub.current_material.settings.thumbnails.front_view;
        var _backView = ub.current_material.settings.thumbnails.back_view;
        var _leftView = ub.current_material.settings.thumbnails.left_view;
        var _rightView = ub.current_material.settings.thumbnails.right_view;
        var _notes = "Richardson Saved Design";

        SaveDesign.prepareOrderData();

        var _data = {
            user_id: "2974",
            name: _designName,
            material_id: _materialID,
            material_name: ub.current_material.material.name,
            user: "Richardson",
            builder_customizations: _builderCustomizations,
            sport: _sport,
            front_thumbnail: _frontView,
            back_thumbnail: _backView,
            left_thumbnail: _leftView,
            right_thumbnail: _rightView,
            notes: _notes,
            brand_id: ub.config.brand_id
        };

        return _data;
    },

    prepareOrderData: function() {
        ub.current_material.settings.orderInfo = {
            brand: ub.current_material.material.brand,
            item_id: ub.current_material.material.item_id,
            type: ub.current_material.material.type,
            description: ub.current_material.material.name,
            design_sheet: ub.current_material.settings.pdfOrderForm,
            sku: ub.current_material.material.sku,
            material_id: ub.current_material.material.id,
            url: ub.config.host + window.document.location.pathname,
            price: ub.funcs.getPrice(ub.current_material.material),
            applicationType: ub.config.uniform_application_type.toTitleCase(),
            application_type: ub.config.uniform_application_type,
            additional_attachments: ub.data.orderAttachment,
            notes: ""
        }
    },

    onErrorOnUploadingThumbnail: function() {
        ub.funcs.showNotification("Something went wrong while generating thumbnails. Please try again later. Send your feedback if the problem persists.", "danger", 3000);
        UIkit.modal("#richardson-saving-option").hide();
    },

    updateDesignWithCallback: function(successHandler, errorHandler) {
        ub.utilities.info("Updating Save Design");
        SaveDesign.updateSavedDesignBuilderCustomization(function(response) {
            if (response.success) {
                if (_.isFunction(successHandler)) {
                    successHandler();
                }
            } else {
                if (_.isFunction(successHandler)) {
                    errorHandler();
                } else {
                    var message = "Something went wrong while updating design! Please try again.";
                    ub.funcs.showNotification(message, "danger", 3000);
                    UIkit.modal("#richardson-saving-option").hide();
                }
            }
        }, function(err) {
            if (_.isFunction(successHandler)) {
                errorHandler();
            } else {
                var message = "Something went wrong while updating design! Please try again.";
                ub.funcs.showNotification(message, "danger", 3000);
                UIkit.modal("#richardson-saving-option").hide();
            }
        });
    }
};